// @flow
import {
    INTEGRATIONS_FBPIXEL,
    INTEGRATIONS_FBPIXEL_SUCCESS,
    INTEGRATIONS_FBPIXEL_FAILED,
    INTEGRATIONS_FBPIXEL_SAVE
} from '../../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    fbpixel: null
};

type IntegrationsAction = { type: string, payload: {} | string };
type State = { loading?: boolean, +value?: boolean, fbpixel?: {} | null, saving?: boolean};

const IntegrationsFbpixel = (state:State = INIT_STATE, action: IntegrationsAction) => {
    switch (action.type) {
        case INTEGRATIONS_FBPIXEL:
            return { ...state, loading: true };
        case INTEGRATIONS_FBPIXEL_SAVE:
            return { ...state, saving: true };
        case INTEGRATIONS_FBPIXEL_SUCCESS:
            return { ...state, fbpixel: action.payload, loading: false, saving: false, error: null };
        case INTEGRATIONS_FBPIXEL_FAILED:
            return { ...state, error: action.payload, loading: false, saveing: false };
        default: return { ...state };
    }
}

export default IntegrationsFbpixel;